import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[ignoreInputScroll]'
})

/*
 example of using it:
  <input matInput
         ignoreInputScroll
         autocomplete="off"
         formControlName="{{ fControl }}"
         placeholder="{{ fControl | translate }}" />
*/

export class IgnoreInputScrollDirective {

  @HostListener('wheel', ['$event'])
  @HostListener('scroll', ['$event'])
  onWheel(event: Event) {
    event.preventDefault();
  }

}
